module.exports = __webpack_public_path__ + "static/img/03.2a7faa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-cgM/03.jpg
// module id = afrZ
// module chunks = 1